/**
 * Slideshow
 */
import Splide from '@splidejs/splide';

export function init() {
  if (document.querySelector('._testSlider .splide')) {
    new Splide('._testSlider .splide', {
      'type': 'loop',
      'autoplay': true,
      'pagination': false,
      'pauseOnHover': true,
      'pauseOnFocus': true,
      'gap': '3rem',
      'autoHeight': true,
      'arrowPath': 'M10.6465 37.6465L28.293 20L10.6465 2.35351L11.3535 1.64648L29.707 20L11.3535 38.3535L10.6465 37.6465Z'
    }).mount();
  }
}
